import React from 'react';
import { useQuery } from '@apollo/client';
import { GET_RECENT_SUBSCRIPTIONS } from '../../../graphql/queries/Auth/QueryAuth';
import {
  Pane,
  Heading,
  Spinner,
  Text,
  Table,
  Link,
  Alert,
  Badge
} from 'evergreen-ui';
import { formatDistanceToNow } from 'date-fns';

const SubscriptionsBox = ({ onSelectPublisher }) => {
  const { loading, error, data } = useQuery(GET_RECENT_SUBSCRIPTIONS, {
    variables: { limit: 10 },
    fetchPolicy: 'network-only'
  });

  if (loading) {
    return (
      <Pane
        elevation={1}
        background="white"
        padding={16}
        marginBottom={16}
        display="flex"
        alignItems="center"
        justifyContent="center"
        height={300}
      >
        <Spinner />
      </Pane>
    );
  }

  if (error) {
    return (
      <Pane
        elevation={1}
        background="white"
        padding={16}
        marginBottom={16}
      >
        <Alert intent="danger" title="Error loading recent subscriptions">
          {error.message}
        </Alert>
      </Pane>
    );
  }

  const recentSubscriptions = data?.recentSubscriptions || [];

  return (
    <Pane
      elevation={1}
      background="white"
      padding={16}
      marginBottom={16}
      height="100%"
    >
      <Heading size={600} marginBottom={16}>Recent Subscriptions</Heading>

      {recentSubscriptions.length === 0 ? (
        <Text>No recent subscriptions found</Text>
      ) : (
        <Table>
          <Table.Head>
            <Table.TextHeaderCell>Publisher</Table.TextHeaderCell>
            <Table.TextHeaderCell>Plan</Table.TextHeaderCell>
            <Table.TextHeaderCell>Date</Table.TextHeaderCell>
          </Table.Head>
          <Table.Body>
            {recentSubscriptions.map(publisher => (
              <Table.Row key={publisher.id} height={24}>
                <Table.TextCell paddingY={6}>
                  <Link
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      onSelectPublisher && onSelectPublisher(publisher);
                    }}
                  >
                    {publisher.name}
                  </Link>
                </Table.TextCell>
                <Table.TextCell paddingY={6}>
                  {publisher.plan ? (
                    <Badge color="green">{publisher.plan}</Badge>
                  ) : 'N/A'}
                </Table.TextCell>
                <Table.TextCell paddingY={6}>
                  {publisher.billingDate ? formatDistanceToNow(new Date(publisher.billingDate), { addSuffix: true }) :
                   publisher.created ? formatDistanceToNow(new Date(publisher.created), { addSuffix: true }) : 'N/A'}
                </Table.TextCell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      )}
    </Pane>
  );
};

export default SubscriptionsBox;
